import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import PathDisplay from "../common/PathDisplay";
import PathInfo from "../../model/PathInfo";
import { useApiClient } from "../../contexts/ApiClientContext";
import APIEndPoints from "../../utils/APIEndPoints";
import CHElement from "../../model/CHElement";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";

/*
  Component to manage the entire CH_ELEMENTS section
*/
function ChElements() {
  // read the ID from the url
  const { id } = useParams();
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (id) {
        const info = await apiClient?.get<CHElement>({
          url: APIEndPoints.CHELEMENTS.ONE(parseInt(id)),
        });

        setPathInfo(
          new PathInfo(
            info.id!,
            info.name,
            ChemiNovaEntityType.CHELEMENT,
            info.parent,
            true
          )
        );
      } else {
        setPathInfo(undefined);
      }
    };
    getPathInfo();
  }, [location, id]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default ChElements;
